import React, { useState, useEffect, useContext } from "react";
import HeroSection from "../components/HeroSection";
import { Container, Box, Button } from "@mui/material";
import img from "../assets/img.png";
import { Link } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import WeCear from "../components/WeCear";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import Footer from "../components/Footer";
import ImagesLogo from "../components/ImagesLogo";
import { cardsStapNewBoiler00 } from "../assets/data";
import Lottie from "react-lottie";
import animationData from "../assets/a1.json";
import { AppContext } from "../context/ContenxtAPI";
const titles = {
  title: (
    <>
      WeCare about
      <br /> your boiler, your home
      <br /> and about you!
    </>
  ),
};

const NewBoiler = (id) => {
  const match140 = useMediaQuery("(max-width:480px)");
  const { boilerService } = useContext(AppContext);
  const [showAnimation, setShowAnimation] = useState(true);
  const [cardsStapNewBoiler, setCardsStapNewBoiler] = useState([]);
  const handleFindOutMore = (id) => {
    setCardsStapNewBoiler(id);
    console.log("id is :", id);
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  useEffect(() => {
    setCardsStapNewBoiler(cardsStapNewBoiler00);
    boilerService();
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <HeroSection title={titles} />
      <Container maxWidth="xl" className="containers">
        <Box className="flexDivs">
          <Box className="sec2div">
            <p className="second_titles_home">
              At WeCare, we understand the <br /> importance of a warm, safe,
              and <br />
              well-maintained home. As a leading <br /> provider of boiler
              repair and home <br /> care services, we take pride in being{" "}
              <br /> your trusted partner in ensuring <br /> your home remains
              comfortable <br /> and secure, all year round.
            </p>
            <Link to="/About">
              {" "}
              <Button variant="contained" className="herobtn">
                Read Our Story
              </Button>
            </Link>
          </Box>
          <Box className="imgdiv">
            <img src={img} alt="" />
          </Box>
        </Box>
      </Container>
      <Box className="containers">
        <WeCear />
      </Box>
      {showAnimation ? (
        <div className="center-animation" id="boilerServices">
          <Lottie options={defaultOptions} height={400} width={400} />
        </div>
      ) : (
        <div className="padinBookRepier oneOffService">
          <div className="servece_text_div" id="boilerServices">
            <h1>
              <span>WeCare,</span> New Boiler Installation
            </h1>
            <p>
              WeCare offers a hassle-free new boiler installation service for
              efficient and reliable heating solutions... Keeping your home warm
              all year round
            </p>
          </div>
          {cardsStapNewBoiler.map((item, index) => (
            <div
              key={index}
              className="new_boiler_div d-flex justify-content-center mt-3 p-3"
            >
              <div
                className="cards_staps newBoiler"
                style={{ maxWidth: "450px" }}
              >
                <div className="card_titles">
                  <h1>{item.title}</h1>
                  <p>{item.caption}</p>
                </div>
                <span className="d-flex cards_price  align-items-baseline">
                  <h1>{item.price}</h1>
               
                </span>
                
               
                <div className="cards_actions">
                  {item.working.map((action, idx) => (
                    <div className="working" key={idx}>
                      <CheckCircleOutlineRoundedIcon style={{ color: '#604CD4' }} className="working boilerCardTickIcon"/>
                      {action}
                    </div>
                  ))}
                </div>
                <div className="cards_actions">
                  {item?.notworking?.map((item, i) => (
                    <div className="notwarking" key={i}>
                      <CancelOutlinedIcon
                        style={{ color: "#604CD4", opacity: "0.6" }}
                      />
                      <span className="spanundesr">{item}</span>
                    </div>
                  ))}
                </div>
                <Link to={`/FindOutMore/${item.id}`}>
                  <Button
                    variant="contained"
                    className="card_btn"
                    onClick={() => handleFindOutMore(item.id)}
                  >
                    Find Out More
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
      <Box className="maincenter">
        <h1 className="its_h1">
          It’s simple and easy to switch
          <br /> your home plan to us today!
        </h1>
        <Link to="/BookRepair">
          <Button variant="contained" className="herobtn">
            Get a Quote
          </Button>
        </Link>
      </Box>

      <div>
        <ImagesLogo />
      </div>
      <Footer />
    </>
  );
};

export default NewBoiler;
